

































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class SelfieSvg extends Vue {
  @Getter("primaryColor") primaryColor;
  @Getter("accentColor") accentColor;
}
